/* eslint-disable @typescript-eslint/no-explicit-any */
export enum ExpenseTypeSR {
    Fuel = <any>'Gorivo',
    Other = <any>'Ostalo',
    RepairAndMaintenance = <any>'Popravke i održavanje',
    RecurringExpense = <any>'Periodični troškovi',
    CalculatorExpense = <any>'Dodatni troškovi',
}
